import React from 'react';

function pad2(n) {
    return String(n).padStart(2, '0');
}

export function formatYmdLocal(date) {
    if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';
    return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
}

export function todayYmdLocal() {
    return formatYmdLocal(new Date());
}

/** Local calendar date N days before today. */
export function daysAgoYmdLocal(days) {
    const d = new Date();
    d.setDate(d.getDate() - days);
    return formatYmdLocal(d);
}

/** Inclusive last 7 local calendar days (today and the 6 days before). */
export function defaultOrderHistoryFromDate() {
    return daysAgoYmdLocal(6);
}

export function defaultOrderHistoryToDate() {
    return todayYmdLocal();
}

function parseOrderCreatedDate(order) {
    if (!order || typeof order !== 'object') return null;
    const raw =
        order.createdDate ??
        order.createdAt ??
        order.CreatedDate ??
        order.created_date ??
        order.created_at ??
        order.Created_Date;
    if (raw == null) return null;
    const s = String(raw).trim();
    if (!s) return null;
    const normalized = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}/.test(s) ? s.replace(' ', 'T') : s;
    const d = new Date(normalized);
    return Number.isNaN(d.getTime()) ? null : d;
}

export function orderCreatedYmd(order) {
    const d = parseOrderCreatedDate(order);
    return d ? formatYmdLocal(d) : '';
}

export function orderMatchesHistoryDateRange(order, fromDate, toDate) {
    if (!fromDate && !toDate) return true;
    const ymd = orderCreatedYmd(order);
    if (!ymd) return false;
    if (fromDate && ymd < fromDate) return false;
    if (toDate && ymd > toDate) return false;
    return true;
}

export default function OrderHistoryDateFilters({
    fromDate,
    toDate,
    onFromDateChange,
    onToDateChange,
    ariaLabel = 'Date range',
}) {
    const handleFromChange = (e) => {
        const next = e.target.value;
        onFromDateChange(next);
        if (next && toDate && next > toDate) {
            onToDateChange(next);
        }
    };

    const handleToChange = (e) => {
        const next = e.target.value;
        onToDateChange(next);
        if (next && fromDate && next < fromDate) {
            onFromDateChange(next);
        }
    };

    return (
        <div className="order-history-date-filters" role="group" aria-label={ariaLabel}>
            <label className="order-history-date-field">
                <span>From</span>
                <input
                    type="date"
                    value={fromDate || ''}
                    max={toDate || undefined}
                    onChange={handleFromChange}
                    aria-label="From date"
                />
            </label>
            <label className="order-history-date-field">
                <span>To</span>
                <input
                    type="date"
                    value={toDate || ''}
                    min={fromDate || undefined}
                    onChange={handleToChange}
                    aria-label="To date"
                />
            </label>
        </div>
    );
}
